.controls {
  display: flex;
  flex: 1 1 22.5rem;
  align-items: center;
  gap: var(--space-2);
}

.input {
  flex: 1 1 16.25rem;
  max-width: 32.5rem;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1-5);
}

.chip {
  display: inline-flex;
  min-height: 1.75rem;
  align-items: stretch;
  overflow: hidden;
  border: 2px solid var(--color-border-subtle);
  border-radius: var(--radius-pill);
  background: var(--color-surface-subtle);
  transition:
    border-color var(--duration-fast) ease,
    opacity var(--duration-fast) ease;
}

.chip:hover,
.chip:focus-within {
  border-color: var(--color-border-control);
}

.chipDisabled {
  opacity: 0.45;
}

.chip {
  --icon-action-outline-offset: -2px;
}

.nameButton {
  border: 0;
  background: transparent;
  cursor: pointer;
}

.toggle {
  width: 1.5rem;
  color: var(--color-fg);
}

.nameButton {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  padding: var(--space-1) var(--space-1-5) var(--space-1) 0;
  color: var(--color-fg);
  font-size: var(--text-xs);
}

.nameInput {
  width: min(16rem, 45vw);
  min-width: 6rem;
  margin: 0;
  padding: 0 var(--space-1);
  border: 0;
  border-inline: 1px solid var(--color-border-control);
  background: rgba(5, 7, 13, 0.36);
  color: var(--color-fg-strong);
  font: inherit;
  font-size: var(--text-xs);
  outline: none;
}

.nameInput:focus-visible,
.nameButton:focus-visible {
  outline: 2px solid color-mix(in oklab, var(--color-focus) 52%, transparent);
  outline-offset: -2px;
}

.swatch {
  width: 0.625rem;
  height: 0.625rem;
  flex-shrink: 0;
  border-radius: 50%;
}

.name {
  overflow: hidden;
  max-width: 16rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chipDisabled .name {
  text-decoration: line-through;
}

.nameButton:hover .name {
  color: var(--color-fg-strong);
  text-decoration: underline dotted;
  text-underline-offset: 0.2em;
}

.remove {
  width: 1.75rem;
  color: var(--color-muted);
}

.remove:hover {
  background: var(--color-error-soft);
  color: var(--color-error);
}

.remove svg {
  width: 0.875rem;
  height: 0.875rem;
}

@media (max-width: 40rem) {
  .controls {
    width: 100%;
  }

  .input {
    min-width: 0;
  }

  .list {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: var(--space-0-5);
  }

  .chip {
    flex: 0 0 auto;
  }
}
